import React, { useReducer, useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Col, Row, Container, Input, Label } from "reactstrap";
import { initialize, defaultState } from "./store/store";
import style from "./Custody.module.scss";
import { custodyReducer, validateForm } from "./store/reducer";
import Footer from "./Footer";
import { Numeric, Combobox, Field } from "../Order/Field/Field";
import Symbol from "../IO/Fields/Symbol";
import Account from "../IO/Fields/Account";
import { CustodyLock, getIntStatusName, CustodyIntStatus } from "../../Custody/types";
import { Mode } from "../../../utils";
import { getEnabledStatus } from "./utils";
import { InternalStatus } from "./../../Custody/Items";
import CircularProgress from "../../CircularProgress/CircularProgress";
import { showToast } from "../../../utils/Helper";

const Custody = ({ open, toggle, services, role, opsViewAccountName, ...props }) => {
  const [state, dispatch] = useReducer(custodyReducer, defaultState(), initialize(props));
  const { fields, custody, ui } = state;
  const { errors, readonly } = fields;

  const [AssetPhysicalDenomination, setAssetPhysicalDenomination] = useState(false);
  const [denominationsUsed, setDenominationsUsed] = useState([]);
  const [denominations, setDenominations] = useState([]);
  const [custodyHasDenomination, setHasDenomination] = useState(
    custody.custodyHasDenomination ? custody.custodyHasDenomination : true
  );

  useEffect(() => {
    if (props.retriveAsync && ui.loading) {
      services.fetchGetCustody({ id: custody.id }).then((r) => {
        dispatch({ type: "SET_CUSTODY", custody: r.custody });
      });
    }

    dispatch({ type: "SET_INITIALS_READONLY" });
  }, []);

  const onChange = (fields) => {
    dispatch({ type: "CHANGE_FIELDS", fields });
  };

  const precheck = () => {
    dispatch({ type: "CHANGE_MODE", mode: Mode.PRECHECK });
    const hasErrors = validateForm(state);

    if (!hasErrors) {
      let order = {
        OrderQuantityIsCash: "false",
        OrderSide: "Sell",
        AssetId: state.custody.assetid,
        CurrentAccount: {
          AccountId: state.custody.AccountId,
          Quantity: state.custody.volume,
        },
      };
      let custodysdt = {
        ...custody,
        externaldate:
          custody.externaldate === "0000-00-00" || custody.externaldate === ""
            ? custody.date
            : custody.externaldate,
      };
      services.precheck({ custodysdt, order }).then((r) => {
        if (r.validation.result.Code == 200) {
          dispatch({ type: "CHANGE_MODE", mode: Mode.CONFIRM });
        } else {
          showToast(r.validation.result.Description, true);
          dispatch({ type: "CHANGE_MODE", mode: Mode.EDIT });
        }
      });
    }
  };

  const confirm = () => {
    dispatch({ type: "CHANGE_BUTTON_PROPS", props: { confirm: { loading: true } } });

    services
      .fetchUpdateCustody({
        k2btrnmode: custody.id ? "UPD" : "INS",
        custody: {
          ...custody,
          assetid: custody.assetid,
          externaldate: custody.externaldate === "0000-00-00" ? custody.date : custody.externaldate,
          denominations: custody.denominationUsed,
        },
      })
      .then((r) => {
        if (r.result.Code === 200) toggle();
        //alert("Ok: " + r.result.Description);
        else {
          showToast("Error: " + r.result.Description, "error");
          dispatch({ type: "CHANGE_BUTTON_PROPS", props: { confirm: { loading: false } } });
          dispatch({ type: "CHANGE_MODE", mode: Mode.PRECHECK });
        }
      });
  };

  const downloadFile = (type) => {
    services.fetchCustodyPdf({ id: custody.id });
  };

  useEffect(() => {
    if (custody) {
      if (custody.assetid) {
        services.fetchGetAssetInformation({ assetId: custody.assetid }).then((response) => {
          setAssetPhysicalDenomination(response.info.AssetPhysicalDenomination);
          onChange({ assetHasDenomination: response.info.AssetPhysicalDenomination });
        });
      }
    }
  }, [custody.assetid]);

  useEffect(() => {
    if (AssetPhysicalDenomination && custody.id) {
      const payload = {
        custodyLockReleaseId: custody.id,
      };
      services
        .getDenominationsByCustodyLock(payload)
        .then((response) => {
          setDenominationsUsed(response.denominations);
          //setDenominations(response.denominations);
          onChange({ denominationUsed: response.denominations });
        })
        .catch((err) => console.error("Error: ", err));
      //setDenominationsUsed(trade.denominationsUsed);
    }
  }, [AssetPhysicalDenomination]);

  useEffect(() => {
    if (AssetPhysicalDenomination && custody.accountId && custody.assetid) {
      const payload = {
        BasicAccountId: custody.accountId,
        AssetId: custody.assetid,
        BalanceType: custody.balancetype ? custody.balancetype : "Current",
        BookType: "Self",
      };
      services.getAvailableDenominationsByAccount(payload).then((response) => {
        setDenominations(response.response ? response.response.denominations : response.denominations);
      });
    }
  }, [AssetPhysicalDenomination, custody.accountId, custody.assetid]);

  useEffect(() => {
    if (custody.custodyHasDenomination != undefined) {
      setHasDenomination(custody.custodyHasDenomination);
    }
  }, [custody.custodyHasDenomination]);

  const onChangeDenomination = (checked, value, index) => {
    let denominationResult = denominationsUsed;
    if (checked) {
      const denominationAdd = [...denominationsUsed, { key: index, DenominationId: value }];
      setDenominationsUsed(denominationAdd);
      denominationResult = denominationAdd;
    } else {
      const updatedDenomination = denominationsUsed.filter((item) => item.DenominationId !== value);
      setDenominationsUsed(updatedDenomination);
      denominationResult = updatedDenomination;
    }
    onChange({ denominationUsed: denominationResult });
  };

  return (
    <Modal isOpen={open} className={style.modal}>
      <ModalHeader toggle={toggle}>Custody</ModalHeader>
      <ModalBody className={style.body}>
        <div className={style.form}>
          {ui.loading && <CircularProgress />}
          {!ui.loading && (
            <Container>
              <Row>
                {/* Left */}
                <Col xs={12} lg={6}>
                  {/* Date */}
                  <Field label={"Date"} error={errors.date}>
                    <Input
                      tabIndex="3"
                      type="date"
                      placeholder={"Date"}
                      disabled={readonly.date}
                      value={custody.date}
                      invalid={!!errors.date}
                      onChange={(e) => onChange({ date: e.target.value })}
                    />
                  </Field>

                  {/* ##### Volume ###### */}
                  <Field label={"Volume"} error={errors.volume}>
                    <Numeric
                      value={custody.volume}
                      placeholder={"Volume"}
                      onChange={(v) => onChange({ volume: v })}
                      invalid={!!errors.volume}
                      dataTypeDecimalName="currency"
                    />
                  </Field>

                  {/* ##### Symbol ###### */}
                  <Symbol
                    isCurrency={false}
                    onChange={(v) =>
                      onChange({
                        assetid: v.AssetId,
                        assetticker: v.AssetTicker,
                      })
                    }
                    error={errors.assetticker}
                    disabled={readonly.assetticker}
                    value={custody.assetticker}
                    fetchSearchSymbol={services.fetchSearchSymbol}
                  />
                  {custody.id != undefined && (
                    <Row>
                      <Col lg={5}>
                        <Field label={"Actual Status"}>
                          <div className={style.box}>{InternalStatus(custody.actualstatus)}</div>
                        </Field>
                      </Col>
                      <Col lg={7}>
                        <Field label={"Next Status"} error={errors.type}>
                          <Combobox
                            value={custody.internalstatus}
                            items={getEnabledStatus(custody).map((key, index) => ({
                              id: key,
                              description: getIntStatusName(key),
                            }))}
                            disabled={custody.actualstatus == CustodyIntStatus.Returned || role == "Advisor"}
                            invalid={!!errors.internalstatus}
                            onChange={(v) => onChange({ internalstatus: v })}
                            emptyLabel={"Internal Status"}
                            style={{ background: "#edf9ff", fontWeight: 500 }}
                          />
                        </Field>
                      </Col>
                    </Row>
                  )}
                </Col>

                {/* Right */}
                <Col xs={12} lg={6}>
                  {/* ##### Account ###### */}
                  <Account
                    label={"Account"}
                    AccountId={custody.accountId}
                    AccountName={opsViewAccountName!== undefined ?
                      (
                        opsViewAccountName ? 
                        (
                           custody.accountName
                        )
                        :
                        (
                          ""
                        )
                      )
                      :
                     (
                      custody.accountName
                     )
                    }
                    AccountNumber={custody.accountNumber}
                    onChange={(f) => onChange(dispatch, f)}
                    filter={[]}
                    hideInstruction={true}
                    hideHolder={true}
                    readonly={{
                      AccountName: readonly.accountName,
                    }}
                    errors={{
                      AccountName: errors.accountName,
                    }}
                    services={{
                      fetchSearchAccount: services.fetchSearchAccount,
                    }}
                  />

                  {custody.internalstatus != CustodyIntStatus.ClientRequest &&
                    custody.internalstatus != CustodyIntStatus.CustodianRequest && (
                      <React.Fragment>
                        {/* Date */}
                        <Field label={"External Date"} error={errors.externaldate}>
                          <Input
                            tabIndex="3"
                            type="date"
                            placeholder={"Ext. Date"}
                            value={custody.externaldate}
                            invalid={!!errors.externaldate}
                            onChange={(e) => onChange({ externaldate: e.target.value })}
                          />
                        </Field>

                        {/* Reference */}
                        <Field label={"Reference"} error={errors.reference}>
                          <Input
                            tabIndex="3"
                            type="text"
                            placeholder={"Reference"}
                            disabled={readonly.reference}
                            value={custody.reference}
                            invalid={!!errors.reference}
                            onChange={(e) => onChange({ reference: e.target.value })}
                          />
                        </Field>

                        {/* Doc Reference */}
                        <Field label={"Doc. Reference"} error={errors.docreference}>
                          <Input
                            tabIndex="3"
                            type="text"
                            placeholder={"Doc. Reference"}
                            disabled={readonly.docreference}
                            value={custody.docreference}
                            invalid={!!errors.docreference}
                            onChange={(e) => onChange({ docreference: e.target.value })}
                          />
                        </Field>
                      </React.Fragment>
                    )}

                  {/* Documents */}
                  {custody.internalstatus != CustodyIntStatus.ClientRequest && (
                    <Field label={"Documents"}>
                      <div className={style.fileList}>
                        <span className={style.link} onClick={() => downloadFile("detail")}>
                          <i className="fa fa-file-pdf-o mr-2" aria-hidden="true"></i>
                          {"Custody detail PDF"}
                        </span>
                      </div>
                    </Field>
                  )}
                </Col>
              </Row>
              <Field>
                {AssetPhysicalDenomination && custodyHasDenomination && (
                  // && isGeneratedFrom == "Default"
                  <div style={{ width: "100%" }}>
                    <hr />
                    <div style={{ display: "flex" }}>
                      <label
                        style={{
                          fontSize: "15px",
                          fontWeight: "bold",
                          marginLeft: "170px",
                          marginRight: "10px",
                        }}
                      >
                        Denomination
                      </label>
                      <Field noLabel error={errors.denominationUsed}></Field>
                    </div>

                    <hr style={{ border: "1px solid #ccc" }} />
                    {denominations.map((denomination, key) => {
                      const isChecked = denominationsUsed.some(
                        (item) => item.DenominationId === denomination.DenominationId
                      );
                      return (
                        <div key={key}>
                          <Row className="align-items-center mb-3">
                            <Col md="auto">
                              <Input
                                key={key}
                                type="checkbox"
                                checked={isChecked}
                                style={{
                                  position: "relative",
                                  cursor: "pointer",
                                  left: "25px",
                                }}
                                disabled={
                                  custody.actualstatus == CustodyIntStatus.Returned ||
                                  (custody.id && custody.internalstatus !== "Client Request")
                                    ? true
                                    : false
                                  // denominationsUsed
                                  //   ? denominationsUsed.some((item) => item.tradeIsAlreadyConfirmed === true)
                                  //   : false
                                }
                                onChange={(e) => {
                                  onChangeDenomination(e.target.checked, denomination.DenominationId, key);
                                }}
                              />
                            </Col>
                            <Col md="auto">
                              <Label style={{ marginLeft: "140px" }}>{denomination.DenominationTicker}</Label>
                            </Col>
                          </Row>
                          <hr />
                        </div>
                      );
                    })}
                  </div>
                )}
              </Field>
            </Container>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Footer
          toggle={toggle}
          dispatch={dispatch}
          buttons={state.buttons}
          actions={{
            precheck,
            confirm,
          }}
        />
      </ModalFooter>
    </Modal>
  );
};

export function validation(custody) {
  if (!custody.assetHasDenomination) {
    if (custody.accountNumber === null){
      return {
        AccountNumber: {empty: true},
        AccountName: {empty: false},
        volume: { empty: true },
        assetticker: { empty: true, autosuggestId: "assetid" },
      };
    }
    else{
      return {
        accountNumber: {empty: true},
        accountName: {empty: false},
        volume: { empty: true },
        assetticker: { empty: true, autosuggestId: "assetid" },
      };
    }
  } else {
    return {
      accountNumber: {empty: true},
      accountName: {empty: false},
      volume: { empty: true },
      assetticker: { empty: true, autosuggestId: "assetid" },
      denominationUsed: {
        empty: !custody.assetHasDenomination ? false : true,
        hasdenomination: true,
      },
    };
  }
}

export default Custody;
